import IconLabel from './IconLabel';

export * from './IconLabel';

export default IconLabel;
